import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';
import recordEvent from 'platform/monitoring/record-event';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

const DisabilityConfirmation = ({ data, goForward }) => {
  // use logging to compare number of short forms started vs completed
  const onConfirm = useCallback(() => {
    recordEvent({ event: 'hca-short-form-flow' });
    goForward(data);
  }, [data, goForward]);

  return (
    <va-alert status="info" class="vads-u-margin-y--4">
      <h1 slot="headline">
        Confirm that you receive service-connected pay for a 50% or higher
        disability rating
      </h1>
      <p>
        You selected that you currently receive service-connected disability pay
        for a 50% or higher disability rating. This means that you meet one of
        our eligibility criteria and we don’t need to ask you some questions.
      </p>
      <FormNavButtonContinue
        goForward={onConfirm}
        primaryButtonText="Confirm"
        useWebComponents
        enableAnalytics
      />
    </va-alert>
  );
};

DisabilityConfirmation.propTypes = {
  data: PropTypes.object,
  goForward: PropTypes.func,
};

export default DisabilityConfirmation;
